if (!customElements.get('custom-option')) {
  class CustomOption extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.init();
    }

    init(){
      // console.log("CustomOption init()");
      this.JSONScriptTag = this.querySelector(`script[type="application/json"]#${this.id}-data`);
      this.data = this.JSONScriptTag ? JSON.parse(this.JSONScriptTag.innerHTML) : {};
      // always scrub the JSON from the front end, we will take what we get at render and use this as the source of truth.
      if(this.JSONScriptTag) this.removeChild(this.JSONScriptTag);
      this.legend = this.querySelector('legend');
      this.radios = this.querySelectorAll('input[type="radio"]');
      this.property = this.dataset.property;
      this.selectedRadio = null;
      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('keydown', this.handleKeydown.bind(this));
    }

    handleKeydown(event){
      // console.log(`handleKeydown(event)`, event);
      if(!event) return;
      if (event.keyCode !== 13) {
        return;
      }
      event.preventDefault();
      this.clickEvent(event.target);
    }

    handleClick(event) {
      // console.log(`handleClick(event)`, event);
      if(!event) return;
      event.preventDefault();
      this.clickEvent(event.target);
    }

    clickEvent(target){
      if(!target) return;
      const targetIsLegend = this.legend === target;
      const childLegend = target.querySelector('legend');
      const targetHasLegend = this.legend === childLegend;
      const targetIsRadio = target.tagName === "INPUT" && target.type === "radio";
      if ( targetIsLegend || targetHasLegend ) {
        this.open();
      } else if(targetIsRadio) {
        this.setSelectedRadio(target);
        this.close();
      }
    }

    open(){
      this.classList.toggle('open');
      this.closeOtherOptions(this);
      this.updateTabIndex();
    }

    close(){
      this.classList.remove('open');
      this.updateTabIndex();
    }

    closeOtherOptions(element){
      if(!element) return;
      const jsSelectors = this.parentElement.querySelectorAll(`.js-selector.open`);
      jsSelectors.forEach((jsSelector)=>{
        jsSelector.classList.remove('open');
        const visualWrapper = jsSelector.querySelector('.Option__wrapper-visual.open');
        if(visualWrapper) visualWrapper.classList.remove('open');
      });
      const otherCustomOptions = this.parentElement.querySelectorAll(`custom-option.open:not(#${element.id})`);
      otherCustomOptions.forEach((otherCustomOption)=>{
        otherCustomOption.classList.remove('open');
        otherCustomOption.updateTabIndex();
      });
    }

    updateTabIndex() {
      const isOpen = this.classList.contains('open');
      this.radios.forEach(radio => {
        const label = radio.closest('label');
        if (label) label.tabIndex = isOpen ? 0 : -1;
      });
    }

    setSelectedRadio(element){
      if(!element) return;
      if(!(element.tagName === "INPUT" && element.type === "radio")) return;
      element.checked = true;
      element.dispatchEvent(new Event('change', { 'bubbles': true }));
      this.selectedRadio = element;
      if(this.legend) this.legend.innerHTML = this.selectedRadio.value;
    }

    getSelectedRadio() {
      return this.selectedRadio;
    }

    getSelectedValue() {
      return this.selectedRadio ? this.selectedRadio.value : null;
    }

    getSelectedData(){
      if (!this.selectedRadio) return null;
      // Find the option in this.data.options that matches the id of the selected radio
      const selectedOption = this.data.options.find(option => option.id === this.selectedRadio.id);
      return selectedOption ? selectedOption : null;
    }

    getPropertyName() {
      return this.property;
    }
  }

  customElements.define('custom-option', CustomOption);
}